import { render, staticRenderFns } from "./AgentsInfo.vue?vue&type=template&id=35e58cf3&scoped=true&"
import script from "./AgentsInfo.vue?vue&type=script&lang=js&"
export * from "./AgentsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AgentsInfo.vue?vue&type=style&index=0&id=35e58cf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e58cf3",
  null
  
)

export default component.exports